import * as React from 'react'

export interface IMediaModal {
  fullBackground?: boolean
  fullScreen?: boolean
  setOpen: (open: boolean) => void
  children: React.ReactNode
}

function MediaModal({
  setOpen,
  children,
  fullScreen,
  fullBackground,
}: IMediaModal) {
  return (
    <div className={`light-box flex justify-center items-center `}>
      <div
        className={`flex justify-center items-center w-full h-full ${
          fullBackground && 'bg-engineering-grey-4'
        } ${
          !fullScreen &&
          'md:aspect-video md:h-auto md:w-3/4 relative bg-engineering-grey-4 '
        }`}
      >
        <div
          className="absolute right-5 top-5 z-[55]
        md:right-6 md:top-6
        xl:right-10 xl:top-10
        "
        >
          <button
            onClick={() => setOpen(false)}
            className="btn btn-circle-small btn-close  "
          ></button>
        </div>

        <div className="aspect-video w-full flex justify-center align-middle item-center">
          {children}
        </div>
      </div>
    </div>
  )
}

export default MediaModal
